"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = void 0;

var _reactDom = require("react-dom");

var _propTypes = require("prop-types");

var _usePortal = require("../../hooks/usePortal");

const propTypes = {
  id: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired
};

const Portal = ({
  id,
  children
}) => {
  const container = (0, _usePortal.usePortal)(id);
  return /*#__PURE__*/(0, _reactDom.createPortal)(children, container);
};

exports.Portal = Portal;
Portal.propTypes = propTypes;